import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useArticles } from "../../../hooks/useArticles";
import { toNewsItems } from "../../../lib/articleAdapter";
import NewsCard from "./NewsCard";

interface LatestNewsProps {
  onArticlesLoaded?: (ids: number[]) => void;
}

export default function LatestNews({ onArticlesLoaded }: LatestNewsProps) {
  const { articles, loading } = useArticles();
  const items = toNewsItems(articles).slice(0, 4);

  // Notificar al padre los IDs que estamos mostrando, para que otras secciones las excluyan
  useEffect(() => {
    if (articles.length > 0 && onArticlesLoaded) {
      const ids = articles.slice(0, 4).map((a) => a.id);
      onArticlesLoaded(ids);
    }
  }, [articles, onArticlesLoaded]);

  if (loading) {
    return (
      <section className="bg-white py-4 md:py-8">
        <div className="max-w-screen-xl mx-auto px-4 md:px-6">
          <div className="flex items-center gap-4 mb-4 md:mb-6">
            <div className="w-1 h-9 bg-red-500 rounded-full animate-pulse" />
            <div className="h-7 bg-slate-200 rounded w-40 animate-pulse" />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="h-72 bg-slate-100 rounded-2xl animate-pulse" />
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (items.length === 0) {
    return null;
  }

  return (
    <section className="bg-white py-4 md:py-8">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex items-center justify-between mb-4 md:mb-6">
          <div className="flex items-center gap-4">
            <div className="w-1 h-9 bg-red-500 rounded-full" />
            <div>
              <h2
                className="text-[#0B1F3A] font-extrabold"
                style={{ fontFamily: "'Sora', sans-serif", fontSize: "1.5rem" }}
              >
                Últimas Noticias
              </h2>
              <p
                className="text-slate-400 text-xs mt-0.5"
                style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
              >
                Lo más reciente del sector aeronáutico
              </p>
            </div>
          </div>
          <Link
            to="/actualidad"
            className="hidden sm:flex items-center gap-2 text-slate-500 text-sm font-semibold hover:text-slate-700 transition-colors cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
          >
            Ver todas <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {items.map((item) => (
            <NewsCard key={item.id} item={item} variant="compact" />
          ))}
        </div>

        {/* Mobile CTA */}
        <div className="mt-4 md:mt-6 text-center sm:hidden">
          <Link
            to="/actualidad"
            className="inline-flex items-center gap-2 px-6 py-3 bg-[#0B1F3A] text-white text-sm font-semibold rounded-xl cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
          >
            Ver todas las noticias <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}